import { Fragment, useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { ActionButton, BackButton, Alert, DataStatus } from 'components';
import { PurchaseOrderApi } from 'api';
import {
  FormSection,
  InformasiVendorSection,
  TableListPurchaseOrder,
} from './Components';
import { withDropdownPurchaseOrderContextProvider } from './Contexts';

const TambahPurchaseOrder = withDropdownPurchaseOrderContextProvider(
  ({ setNavbarTitle }) => {
    const TODAY = new Date();
    const history = useHistory();
    const { id_vendor } = useParams();

    const [isPageLoading, setIsPageLoading] = useState(false);
    const [isFetchingFailed, setIsFetchingFailed] = useState(false);
    const [dataPurchaseOrder, setDataPurchaseOrder] = useState({
      info: {},
      detail: [],
    });
    const [alertConfig, setAlertConfig] = useState({
      show: false,
      variant: 'primary',
      text: '',
    });

    const getInitialData = () => {
      setIsPageLoading(true);

      PurchaseOrderApi.getSingleVendor({ id_vendor })
        .then((res) => {
          const data = res.data.data ?? {};
          const { detail, ...info } = data;

          setDataPurchaseOrder({ info, detail });
        })
        .catch(() => setIsFetchingFailed(true))
        .finally(() => setIsPageLoading(false));
    };

    useEffect(() => {
      setNavbarTitle('Purchase Order');
      getInitialData();

      return () => setIsPageLoading(false);
    }, []);

    const defaultKeterangan = dataPurchaseOrder?.detail
      ?.map(
        (item) =>
          `Seleksi Vendor No. ${item.no_seleksi_vendor}: ${
            item.nama_proyek ? `Proyek ${item.nama_proyek} ` : ''
          }`
      )
      .join('\n');

    const initialValues = {
      id_vendor,
      no_purchase_order: '',
      tgl_purchase_order: TODAY,
      tgl_pengiriman: TODAY,
      tgl_jatuh_tempo: TODAY,
      nama_vendor: dataPurchaseOrder.info.nama_vendor,
      kode_vendor: dataPurchaseOrder.info.kode_vendor,
      alamat_tujuan_pengiriman:
        dataPurchaseOrder.alamat_tujuan_pengiriman ??
        'PT. MARDIKA GRIYA PRASTA (Jl. Sekarsari No.30, Kesambi, Denpasar, Bali, Indonesia)',
      alamat_vendor: dataPurchaseOrder.info.alamat_vendor,
      contact_person: dataPurchaseOrder.info.contact_person,
      keterangan: dataPurchaseOrder.keterangan ?? defaultKeterangan,
      diskon: dataPurchaseOrder.diskon ?? '0',
      ppn: dataPurchaseOrder.ppn ?? '0',
      dp: dataPurchaseOrder.dp ?? '0',
      pembayaran: '',
      detail: dataPurchaseOrder?.detail ?? [],
    };

    const validationSchema = Yup.object().shape({
      id_vendor: Yup.string().required('Pilih vendor'),
      tgl_purchase_order: Yup.string().required('Pilih tanggal purchase order'),
      alamat_tujuan_pengiriman: Yup.string().required(
        'Masukan alamat tujuan pengiriman'
      ),
      pembayaran: Yup.string().required('Masukan Pembayaran'),
    });

    const onSubmit = (values, { setSubmitting }) => {
      const finalValue = {
        ...values,
        tgl_purchase_order: values.tgl_purchase_order,
        tgl_pengiriman: values.tgl_pengiriman,
        tgl_jatuh_tempo: values.tgl_jatuh_tempo,
        ppn: values?.ppn ?? 0,
        diskon: values.diskon ?? 0,
        dp: values.dp ?? 0,
        detail:
          values.detail
            .filter((item) => item.checked)
            .map((item) => ({
              id_seleksi_vendor_detail: [`${item.id_seleksi_vendor_detail}`],
              id_item_buaso: item.id_item_buaso,
              qty_order: item.qty_order,
              harga_kesepakatan: item.harga_kesepakatan,
            })) ?? [],
      };

      PurchaseOrderApi.createOrUpdate(finalValue)
        .then(() => {
          history.push('/transaksi/purchase-order', {
            alert: {
              show: true,
              variant: 'primary',
              text: 'Data berhasil ditambah!',
            },
          });
        })
        .catch(() => {
          setAlertConfig({
            show: true,
            variant: 'danger',
            text: 'Data gagal ditambah!',
          });
        })
        .finally(() => setSubmitting(false));
    };

    return (
      <Fragment>
        <Row className="d-flex justify-content-between align-items-end mb-1">
          <Col>
            <b>Tambah Data Purchase Order</b>
          </Col>
          <Col className="d-flex justify-content-end ">
            <BackButton onClick={() => history.goBack()} />
          </Col>
        </Row>

        <Alert
          showCloseButton
          show={alertConfig.show}
          variant={alertConfig.variant}
          text={alertConfig.text}
          onClose={() =>
            setAlertConfig({
              ...alertConfig,
              show: false,
            })
          }
        />

        {isPageLoading || isFetchingFailed ? (
          <DataStatus
            loading={isPageLoading}
            text={isFetchingFailed ? 'Data gagal dimuat!' : 'Memuat data...'}
          />
        ) : (
          <Formik
            enableReinitialize
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
          >
            {({ handleSubmit, isSubmitting }) => (
              <Fragment>
                <FormSection />
                <InformasiVendorSection />
                <TableListPurchaseOrder />
                <Row className="py-3">
                  <Col className="d-flex justify-content-end">
                    <ActionButton
                      text="Simpan"
                      onClick={handleSubmit}
                      loading={isSubmitting}
                    />
                  </Col>
                </Row>
              </Fragment>
            )}
          </Formik>
        )}
      </Fragment>
    );
  }
);

export default TambahPurchaseOrder;
